import { createActionTypes } from 'utils/action/actionTypes';

export const FETCH_CHARGE_COIN = createActionTypes('FETCH_CHARGE_COIN');
export const UPDATE_CHARGE_COIN = createActionTypes('UPDATE_CHARGE_COIN');
export const UPDATE_CHARGE_COIN_LEVEL = createActionTypes('UPDATE_CHARGE_COIN_LEVEL');
export const DELETE_CHARGE_COIN_LEVEL = createActionTypes('DELETE_CHARGE_COIN_LEVEL');
